import { MrDialog } from '@mrhenry/wp--mr-interactive';

customElements.define( 'mr-dialog', MrDialog );
